import { render, staticRenderFns } from "./aFeeDetailImport.vue?vue&type=template&id=8c45e53c&scoped=true"
import script from "./aFeeDetailImport.vue?vue&type=script&lang=js"
export * from "./aFeeDetailImport.vue?vue&type=script&lang=js"
import style0 from "./aFeeDetailImport.vue?vue&type=style&index=0&id=8c45e53c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_a6c7c6c484daeff6636bea47b922569f/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c45e53c",
  null
  
)

export default component.exports